module.exports = __webpack_public_path__ + "img/中繼站1_說明跳窗.631e2a71.png";